import { axiosClient } from './AxiosClient'

function listUser(departmentId, companyId, callback, errorCallback){
    let url = "/account/admin/list_all";

    var formData = new FormData()
    formData.append('building_id', localStorage.getItem('building_id'))
    if(companyId !== ""){
        formData.append("company_id", companyId)
    }
    if(departmentId !== ""){
        formData.append("department_id", departmentId)
    }

    axiosClient.post(url, formData)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteUser(userId, callback, errorCallback){
    let url = "/account/admin/delete";

    var formData = new FormData()
    formData.append("user_id", userId)

    axiosClient.post(url, formData)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewUser(userId, callback, errorCallback){
    let url = "/account/admin/view";

    var formData = new FormData()
    formData.append("user_id", userId)

    axiosClient.post(url, formData)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}


function createUser(
    employeeId,
    username,
    firstname,
    lastname,
    position,
    phoneNumber,
    line,
    email,
    password,
    isCms,
    isMobile,
    isTablet,
    isInformation,
    callback,
    errorCallback
){
    let url = "/account/admin/create"

    var bodyData = {
        username: username,
        password: password,
        firstName: firstname,
        lastName: lastname,
        employeeId: employeeId,
        profileImagePath: "",
        email: email,
        line: line,
        phone: phoneNumber,
        position: position,
        isCms: isCms,
        isMobile: isMobile,
        isTablet: isTablet,
        isInformationScreen: isInformation
    }

    axiosClient.post(url, bodyData, {
        headers:{
            "Content-type": "application/json; charset=utf-8"
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        console.log(error.response)
        errorCallback(error)
    })
}

function updateUser(
    userId,
    username,
    firstname,
    lastname,
    position,
    phoneNumber,
    email,
    isCms,
    isMobile,
    isTablet,
    isInformation,
    callback,
    errorCallback
){
    let url = "/account/admin/edit"

    var bodyData = new FormData()
    bodyData.append("user_id", userId)
    bodyData.append("email", email)
    bodyData.append("first_name", firstname)
    bodyData.append("last_name", lastname)
    bodyData.append("position", position)
    bodyData.append("phone_number", phoneNumber)
    bodyData.append("is_cms", isCms)
    bodyData.append("is_mobile", isMobile)
    bodyData.append("is_tablet", isTablet)
    bodyData.append("is_information", isInformation)
    if(username !== null){
        bodyData.append("username", username)
    }

    axiosClient.post(url, bodyData)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        console.log(error)
        errorCallback(error)
    })
}

function addUserRole(userId, roleId, callback, errorCallback){
    let url = "/account/admin/add_role"

    var bodyData = new FormData()
    bodyData.append("user_id", userId)
    bodyData.append("role_id", roleId)

    axiosClient.post(url, bodyData)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeUserRole(userId, roleId, callback, errorCallback){
    let url = "/account/admin/remove_role"

    var bodyData = new FormData()
    bodyData.append("user_id", userId)
    bodyData.append("role_id", roleId)

    axiosClient.post(url, bodyData)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { listUser, deleteUser, createUser, viewUser, updateUser, addUserRole, removeUserRole }